import api from '../api'

export default {
    namespaced:true,
    state:{

    },
    mutations:{

    },
    actions:{
        createBroadcast(store,params){
            return api.post('/system/broadcast/broadcastCreate','牌局广播创建',params)
        },
        closeRoom(store,params){
            return api.post('/system/user/force-close','强制解散房间',params)
        },
        sendSysMessage(store,params){
            return api.post('/system/message/sendSysMessage','发送系统消息',params)
        }
    }
}